<template>
    <div class="module-wa-autosender">
        <SOSlotBase :container-name="'register-step-1-content'" :loading="!formReady">
            <template v-slot:title-bar>
                <div>
                    <SOTitleBar :page-title="pageTitle" :type="'back'" @back="back" />
                </div>
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content>
                <div class="p-t-16 vh-100 d-grid-12" v-if="formReady">
                    <div class="p-x-20 grid-cspan-12">
                        <SOStep :step="2" :total="3" v-if="!isUpdate" />
                        <p class="f-16 f-c-black f-regular" v-if="!isUpdate">
                            Pilih paket kuota yang ingin anda gunakan
                        </p>
                        <div v-if="isUpdate" class="d-flex f-12 f-c-midgrey f-regular" style="align-items: baseline;">
                            <div class="no-telp">
                                <IconBased width="14" height="14">
                                    <template v-slot:icons>
                                        <WhatsappIconMini clr-fill="#6F7287" />
                                    </template>
                                </IconBased>
                                <span class="m-l-4">+{{ dataDevice.country_code }}{{ dataDevice.nomor }}</span>
                            </div>
                            <label>{{ dataDevice.nama }}</label>
                        </div>
                        <div
                            class="m-d-16"
                            v-for="(list, idx) in paketWhatsapp"
                            :id="`${list.id}-paket`"
                            :key="`${idx}-paket-wa`"
                            :class="{ selected: isSelected(list), unSelect: !isSelected(list) }"
                        >
                            <SOSlotCard :id="`card-${idx}-paket-wa`">
                                <template v-slot:card_body>
                                    <div class="d-grid-12 f-14" @click="doSelect(list)">
                                        <div class="grid-cspan-10 m-d-0 f-16 f-c-black">
                                            {{ list.nama }}
                                        </div>
                                        <div class="grid-cspan-2 d-flex" style="justify-content: flex-end;">
                                            <IconBased width="16" height="16" v-if="isSelected(list)">
                                                <template v-slot:icons>
                                                    <RadioCheckedBlue />
                                                </template>
                                            </IconBased>
                                            <IconBased width="16" height="16" v-if="!isSelected(list)">
                                                <template v-slot:icons>
                                                    <RadioUnChecked />
                                                </template>
                                            </IconBased>
                                        </div>
                                        <div class="grid-cspan-12">
                                            Kuota {{ list.quota }} pesan / {{ list.masa_aktif }} hari
                                        </div>
                                        <div class="grid-cspan-12 f-c-blue">
                                            {{ list.harga | currency }}
                                        </div>
                                    </div>
                                </template>
                            </SOSlotCard>
                        </div>
                        <ErrorMessage class="error" label="Paket Kuota" :validation="$v.registered.id_paket" />
                    </div>
                    <div class="p-x-20 grid-cspan-12" v-if="showRenew">
                        <div class="f-16 f-regular f-c-black d-flex">
                            <div @click="toggleCheck">
                                <SOCheckBox :isChecked="isOtomatis" />
                            </div>
                            <label class="m-d-10 m-l-8">
                                <span @click="toggleCheck">Perpanjang otomatis</span>
                                <span class="m-l-8 m-r-8">•</span>
                                <span class="f-c-blue" @click="showDetail">Lihat detail</span>
                            </label>
                        </div>
                        <SOButton
                            :primary="true"
                            :full="true"
                            :text="'Berikutnya'"
                            :id="`next-register`"
                            @action="nextStep"
                        />
                    </div>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOCheckBox from "@/so-components/global/ui/SOCheckBox";

import SOButton from "@/so-components/global/ui/SOButton";
import SOStep from "@/so-components/global/ui/SOStep.vue";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard.vue";
import ErrorMessage from "@/component-items/ErrorMessage";

import IconBased from "../components/iconPack/IconBased.vue";
import CheckedBlue from "../components/iconPack/CheckedBlue.vue";
import UnChecked from "../components/iconPack/UnChecked.vue";
import WhatsappIconMini from "../components/iconPack/WhatsappIcon1414.vue";
import RadioCheckedBlue from "../components/iconPack/RadioCheckedBlue1616.vue";
import RadioUnChecked from "../components/iconPack/RadioUnChecked1616.vue";

import { required } from "vuelidate/lib/validators";

import { moduleName } from "../store/state";

export default {
    name: "RegisterStep2",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOButton,
        SOStep,
        ErrorMessage,
        SOSlotCard,
        SOCheckBox,
        IconBased,
        CheckedBlue,
        UnChecked,
        RadioCheckedBlue,
        RadioUnChecked,
        WhatsappIconMini,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (to.name === "wa_autosender.detail_perangkat.ubah_paket_1") {
                vm.setBackLink("wa_autosender.detail_perangkat");
                vm.setUpdate(true);
                vm.toggleShowRenew(false);
                vm.setDataRegistered();

                if (from.name === "wa_autosender.detail_perangkat.ubah_paket_2") {
                    vm.setSelected(vm.registered);
                }
            } else {
                if (!vm.isDoneStep1) {
                    vm.back();
                }
            }
        });
    },
    data() {
        return {
            formReady: false,
            selected: {},
            isOtomatis: false,
            backLink: "wa_autosender.register.step1",
            isUpdate: false,
            showRenew: true,
        };
    },
    mounted() {
        this.init();
        this.smartTrackingView("add_perangkat_whatsapp_step2");

    },
    watch: {
        response: function(newRes, oldRes) {
            if (newRes.success) {
                this.setFormReady(true);
            }
        },
        selected: function(newVal, oldVal) {
            if (newVal.id !== oldVal.id) {
                setTimeout(() => {
                    this.setCssSelected();
                }, 50);
            }
        },
        formReady: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.isOtomatis = this.autoUpdate;
            }
        },
        dataDevice: function(newDt, oldDt) {
            if (this.isUpdate) {
                if (newDt.nomor && newDt.nomor !== oldDt.nomor) {
                    this.setDataRegistered();
                }
            }
        },
    },
    validations: {
        registered: {
            id_paket: {
                required,
            },
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            dataDevice: "dataDevice",
            registered: "registered",
            paketWhatsapp: "paketWhatsapp",
            response: "response",
        }),
        isDoneStep1() {
            let { nomor, nama } = this.registered;
            return nomor && nama ? true : false;
        },
        selectedPaket() {
            return this.$route.query.customTitle
                ? this.selected.id
                    ? this.selected.id
                    : ""
                : this.registered.id_paket;
        },
        autoUpdate() {
            return this.registered.auto_renewal ? true : false;
        },
        isSelected() {
            return (list) => {
                return this.selectedPaket === list.id;
            };
        },
        qTitle() {
            return this.$route.query?.customTitle || "Ubah paket";
        },
        pageTitle() {
            return this.isUpdate ? this.qTitle : "Registrasi WA Autosender";
        },
    },
    methods: {
        ...mapActions({
            setRegistered: `${moduleName}/setRegistered`,
            getListPaket: `${moduleName}/getListPaket`,
            getDetailDevice: `${moduleName}/getDetailDevice`,
            setVoucher: `${moduleName}/setVoucher`,
        }),
        init() {
            this.getListPaket();
        },
        setDataRegistered() {
            if (!this.dataDevice.nomor) {
                this.getDetailDevice({ id_mesin: this.$route.params.id_device });
            } else {
                this.setRegistered({ key: "iddevice", val: this.dataDevice.iddevice });
                this.setRegistered({ key: "nomor", val: this.dataDevice.nomor });
                this.setRegistered({ key: "nama", val: this.dataDevice.nama });
                if (!this.registered.id_paket) {
                    this.setRegistered({ key: "id_paket", val: this.dataDevice.idpaket });
                }
                this.setRegistered({ key: "auto_renewal", val: this.dataDevice.auto_renewal });
                this.setRegistered({ key: "kode_kupon", val: "" });
                this.setRegistered({ key: "jenis_pembayaran", val: "" });
                this.setRegistered({ key: "idoutlet", val: this.dataDevice.outlet_coin == null ? "" : this.dataDevice.outlet_coin.idoutlet });
            }
        },
        setBackLink(val) {
            this.backLink = val;
        },
        setUpdate(val) {
            this.isUpdate = val;
        },
        toggleShowRenew(val) {
            this.showRenew = val;
        },
        setCssSelected() {
            let elSelected = document.getElementsByClassName("selected");
            let elUnselect = document.getElementsByClassName("unSelect");

            if (elSelected[0]) {
                elSelected[0].firstChild.firstChild.style.backgroundColor = "#edf5ff";
                elSelected[0].firstChild.firstChild.style.borderColor = "#206CFF";
            } else {
                elSelected = document.getElementById(`${this.selected.id}-paket`);
                elSelected.firstChild.firstChild.style.backgroundColor = "#edf5ff";
                elSelected.firstChild.firstChild.style.borderColor = "#206CFF";
            }

            if (elUnselect) {
                elUnselect.forEach((element) => {
                    element.firstChild.firstChild.style.backgroundColor = "#ffffff";
                    element.firstChild.firstChild.style.borderColor = "#c8d0dd";
                });
            }
        },
        back() {
            this.$router.push({ name: this.backLink });
        },
        setSelected(val) {
            this.selected.id = val.id_paket;
            this.setRegistered({ key: "id_paket", val: val.id_paket });
            this.toggleShowRenew(true);
        },
        doSelect(val) {
            this.selected = val;
            this.setRegistered({ key: "id_paket", val: val.id });
            this.toggleShowRenew(true);
        },
        toggleCheck() {
            this.isOtomatis = !this.isOtomatis;
            this.setRegistered({ key: "auto_renewal", val: this.isOtomatis ? 1 : 0 });
        },
        setFormReady(val) {
            this.formReady = val;
        },
        showDetail() {
            this.$router.push({ name: "wa_autosender.register.detail_info" });
        },
        isValid() {
            let { id_paket } = this.$v.registered;
            id_paket.$touch();

            return id_paket.$invalid;
        },
        nextStep() {
            if (this.isValid()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }

            let goto = "wa_autosender.register.step3";
            if (this.isUpdate) {
                goto = "wa_autosender.detail_perangkat.ubah_paket_2";
            }

            this.$router.push({ name: goto, query: this.$route.query });
            this.smartTrackingClick("add_perangkat_whatsapp_step3");

        },
    },
};
</script>

<style scoped>
.no-telp {
    border: 1px solid #ededed;
    width: fit-content;
    padding: 2px 4px;
    border-radius: 4px;
    margin-right: 4px;
}
</style>
